import { BaseTag } from '@/components';
import type { FC } from 'react';
import type { z } from 'zod';

import {
  CommentPublishTypeLabelModifier,
  type commentPublishType,
} from '../../models/comment';

type Props = {
  publishType: z.infer<typeof commentPublishType>;
};

export const CommentPublishTag: FC<Props> = ({ publishType }) => {
  return (
    <BaseTag
      color={
        publishType === 'open' || publishType === 'strict' ? 'blue' : 'white'
      }
    >
      {CommentPublishTypeLabelModifier[publishType]}
    </BaseTag>
  );
};
